import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formMaxWidth } from '../constants/general-info-constants';
import {
    getProjectDescription,
    postProjectDescription
} from '../../../../../../../actions/rof-burns/01-project-info/01-general-info';
import GeneralInfoForm from '../shared-components/GeneralInfoForm';

const defaultFormState = {
    description: '',
    location: '',
    timeFrame: '',
    entityRoles: '',
}

export default function ProjectDescription({ projectId, selectedCategory }) {
    const dispatch = useDispatch()
    const [formState, setFormState] = useState(defaultFormState)
    const [formErrors, setFormErrors] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const projectDescriptionData = useSelector((state) => (state.generalInfoReducer.projectDescription?.data));

    useEffect(() => {
        handleFormErrorReset()
        dispatch(getProjectDescription(projectId))
    }, [selectedCategory, projectId])

    useEffect(() => {
        if (projectDescriptionData)
            setFormState({
                description: projectDescriptionData?.description,
                location: projectDescriptionData?.location,
                timeFrame: projectDescriptionData?.time_frame,
                entityRoles: projectDescriptionData?.entity_roles,
            })
        else {
            setFormState(defaultFormState)
        }

    }, [selectedCategory, projectId, projectDescriptionData])

    const projectDescriptionQuestions = (formState) => {
        const { description, location, timeFrame, entityRoles } = formState
        return [
            {
                type: 'text',
                fieldId: 'description',
                text: 'Please provide a short paragraph description of this project:',
                value: description,
                multiline: true,
                rows: 3,
                placeholder: 'Describe the project.'
            },
            {
                type: 'text',
                fieldId: 'location',
                text: 'Where is the project taking place?',
                value: location,
                placeholder: 'Enter location.'
            },
            {
                type: 'text',
                fieldId: 'timeFrame',
                text:
                    'When is the project starting and what is the predicted time frame for the activities?',
                value: timeFrame,
                placeholder: 'Project start time and details.'
            },
            {
                type: 'text',
                fieldId: 'entityRoles',
                text:
                    'Please list all the main entities involved in this project and their role:',
                value: entityRoles,
                placeholder: 'Details of collaboration.'
            },
        ]
    }

    const onSubmit = async () => {
        try {
            setIsLoading(true)
            const submissionForm = { ...formState };

            await dispatch(postProjectDescription(submissionForm, projectId))
            await dispatch(getProjectDescription(projectId))
        } catch (error) {
            setFormErrors(error.message)
        } finally { setIsLoading(false) }
    }

    const setData = (event) => {
        const { name, type } = event.target;
        let value = event.target.value

        if (type === 'file') {
            value = event.target.files[0]
        }

        setFormState(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }

    const handleFormErrorReset = () => {
        setFormErrors(null);
    };

    const questions = projectDescriptionQuestions(formState)

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: formMaxWidth }}>
            <Typography variant='h4' sx={{ pb: 2 }}>
                {selectedCategory}
            </Typography>
            <GeneralInfoForm
                formObjectArray={questions}
                formState={formState}
                formErrors={formErrors}
                isLoading={isLoading}
                onChange={setData}
                onSubmit={onSubmit} />
        </Box>
    )
}
